// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox_input__L4q0S {
    display: none;
}

.checkbox_label__jMYFB {
    display: flex;
    align-items: center;
    font-size: var(--checkbox-font-size, 14px);
    font-weight: 300;
    line-height: 16px;
    color: #000000;
    cursor: pointer;
    transition: opacity 0.4s;
    grid-gap: 10px;
    flex: 1 1;
}

label.checkbox_label__jMYFB.checkbox_offset__FI4gk {
    margin-bottom: 16px;
}

.checkbox_checkbox__cRVoc {
    --box-size: 18px;
    --border-width: 3px;

    --check-width: 3px;
    --check-height: 8px;

    display: flex;
    border: 1px solid #7b848e;
    width: var(--box-size);
    min-width: var(--box-size);
    height: var(--box-size);
    border-radius: var(--border-width);
    transition: background-color 0.4s;
}

.checkbox_checkbox__cRVoc.checkbox_checked__MAW5b {
    background: var(--checkbox-bg-color, #fff);
    border-color: var(--primary-color-active);
}

.checkbox_checkbox__cRVoc:after {
    content: '';
    display: block;
    margin: calc(var(--box-size) / 2 - var(--check-height) + 1px) auto auto;
    width: var(--check-width);
    height: var(--check-height);
    transform: rotate(45deg);
    border-bottom: 2px solid var(--primary-color);
    border-right: 2px solid var(--primary-color);
    opacity: 0;
    transition: opacity 0.4s;
}

.checkbox_checkbox__cRVoc.checkbox_checked__MAW5b:after {
    opacity: 1;
}

.checkbox_disabled__mTSXb .checkbox_checkbox__cRVoc
/*, .disabled .label */ {
    opacity: 0.4;
}

.checkbox_readOnly__-n6K0 {
    pointer-events: none;
}

.checkbox_tip__GFx7y {
    display: inline-flex;
    position: relative;
    justify-content: center;
    padding-left: 4px;
    margin: auto 0 auto auto;
}

.checkbox_tipBtn__UziD0 {
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px 0;
    border: 0;
    color: #000000;
    font-size: 14px;
    margin: auto;
}

.checkbox_tipBtnImg__zgWn5 {
    position: relative;
    display: inline-flex;
}

.checkbox_tipBtn__UziD0 img:last-child {
    position: absolute;
    bottom: 0;
    opacity: 0;
}

.checkbox_tipBtn__UziD0 img {
    width: 20px;
    transition: opacity 0.4s;
}

.checkbox_tipBtn__UziD0 span:first-letter {
    text-transform: capitalize;
}

.checkbox_tip__GFx7y:hover img {
    opacity: 1;
}

.checkbox_tip__GFx7y:hover svg text {
    fill: #fff;
}

.checkbox_tip__GFx7y:hover .checkbox_tipBox__W5SUS {
    opacity: 1;
    pointer-events: all;
    z-index: 99;
}

.checkbox_tipBox__W5SUS {
    position: absolute;
    width: 275px;
    background: #7b848e;
    padding: 10px 16px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
    max-height: 500px;
    overflow: auto;
    z-index: -1;
    text-align: center;
}

.checkbox_tipBox__W5SUS:first-letter {
    text-transform: capitalize;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    /*.checkbox {*/
    /*    --box-size: 18px;*/
    /*    --border-width: 3px;*/

    /*    --check-width: 6px;*/
    /*    --check-height: 9px;*/
    /*}*/

    .checkbox_checkbox__cRVoc:after {
        border-width: 1px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/checkbox.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,cAAc;IACd,SAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;;IAEnB,kBAAkB;IAClB,mBAAmB;;IAEnB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,cAAc;IACd,uEAAuE;IACvE,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,6CAA6C;IAC7C,4CAA4C;IAC5C,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,SAAS;IACT,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,2BAA2B;;IAE3B,0BAA0B;IAC1B,2BAA2B;IAC3B,IAAI;;IAEJ;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.input {\n    display: none;\n}\n\n.label {\n    display: flex;\n    align-items: center;\n    font-size: var(--checkbox-font-size, 14px);\n    font-weight: 300;\n    line-height: 16px;\n    color: #000000;\n    cursor: pointer;\n    transition: opacity 0.4s;\n    grid-gap: 10px;\n    flex: 1;\n}\n\nlabel.label.offset {\n    margin-bottom: 16px;\n}\n\n.checkbox {\n    --box-size: 18px;\n    --border-width: 3px;\n\n    --check-width: 3px;\n    --check-height: 8px;\n\n    display: flex;\n    border: 1px solid #7b848e;\n    width: var(--box-size);\n    min-width: var(--box-size);\n    height: var(--box-size);\n    border-radius: var(--border-width);\n    transition: background-color 0.4s;\n}\n\n.checkbox.checked {\n    background: var(--checkbox-bg-color, #fff);\n    border-color: var(--primary-color-active);\n}\n\n.checkbox:after {\n    content: '';\n    display: block;\n    margin: calc(var(--box-size) / 2 - var(--check-height) + 1px) auto auto;\n    width: var(--check-width);\n    height: var(--check-height);\n    transform: rotate(45deg);\n    border-bottom: 2px solid var(--primary-color);\n    border-right: 2px solid var(--primary-color);\n    opacity: 0;\n    transition: opacity 0.4s;\n}\n\n.checkbox.checked:after {\n    opacity: 1;\n}\n\n.disabled .checkbox\n/*, .disabled .label */ {\n    opacity: 0.4;\n}\n\n.readOnly {\n    pointer-events: none;\n}\n\n.tip {\n    display: inline-flex;\n    position: relative;\n    justify-content: center;\n    padding-left: 4px;\n    margin: auto 0 auto auto;\n}\n\n.tipBtn {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 0;\n    border: 0;\n    color: #000000;\n    font-size: 14px;\n    margin: auto;\n}\n\n.tipBtnImg {\n    position: relative;\n    display: inline-flex;\n}\n\n.tipBtn img:last-child {\n    position: absolute;\n    bottom: 0;\n    opacity: 0;\n}\n\n.tipBtn img {\n    width: 20px;\n    transition: opacity 0.4s;\n}\n\n.tipBtn span:first-letter {\n    text-transform: capitalize;\n}\n\n.tip:hover img {\n    opacity: 1;\n}\n\n.tip:hover svg text {\n    fill: #fff;\n}\n\n.tip:hover .tipBox {\n    opacity: 1;\n    pointer-events: all;\n    z-index: 99;\n}\n\n.tipBox {\n    position: absolute;\n    width: 275px;\n    background: #7b848e;\n    padding: 10px 16px;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n    color: #fff;\n    font-size: 14px;\n    line-height: 18px;\n    margin: auto;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 24px;\n    opacity: 0;\n    transition: opacity 0.4s;\n    pointer-events: none;\n    max-height: 500px;\n    overflow: auto;\n    z-index: -1;\n    text-align: center;\n}\n\n.tipBox:first-letter {\n    text-transform: capitalize;\n}\n\n@media screen-md-max {\n    /*.checkbox {*/\n    /*    --box-size: 18px;*/\n    /*    --border-width: 3px;*/\n\n    /*    --check-width: 6px;*/\n    /*    --check-height: 9px;*/\n    /*}*/\n\n    .checkbox:after {\n        border-width: 1px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"input": `checkbox_input__L4q0S`,
	"label": `checkbox_label__jMYFB`,
	"offset": `checkbox_offset__FI4gk`,
	"checkbox": `checkbox_checkbox__cRVoc`,
	"checked": `checkbox_checked__MAW5b`,
	"disabled": `checkbox_disabled__mTSXb`,
	"readOnly": `checkbox_readOnly__-n6K0`,
	"tip": `checkbox_tip__GFx7y`,
	"tipBtn": `checkbox_tipBtn__UziD0`,
	"tipBtnImg": `checkbox_tipBtnImg__zgWn5`,
	"tipBox": `checkbox_tipBox__W5SUS`
};
export default ___CSS_LOADER_EXPORT___;
